import React, { Component } from 'react'
import css from './styles.scss'
import { connect } from 'react-redux'

export class ItemPreview extends Component {
  constructor (props) {
    super(props)
    this.state = {
      previewData: null,
      showModal: false,
      templateName: ''
    }
    this.controller = AbortController ? new AbortController() : {}
  }

  listenForEsc () {
    window.removeEventListener('keyup', this.keyedUp)
    window.addEventListener('keyup', this.keyedUp)
  }

  keyedUp = evt => {
    if (evt.keyCode === 27) {
      this.closeModal(true)
    }
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.modal === 'preview' && nextProps.modal !== 'preview') {
      this.closeModal()
    }
  }

  componentWillUnmount () {
    this.controller.abort()
    window.removeEventListener('keyup', this.keyedUp)
  }

  handlePreview = () => {
    this.openModal()
    this.handleGetPreview()
  }

  openModal = () => {
    this.listenForEsc()
    this.setState({ showModal: true })
  }

  handleBgPress = evt => {
    if (evt.target === evt.currentTarget) {
      this.closeModal()
    }
  }

  closeModal = (backToItem = false) => {
    window.removeEventListener('keyup', this.keyedUp)
    this.setState({
      previewData: null,
      showModal: false
    })
    if (backToItem) {
      this.props.onClearModal()
    }
  }

  handleGetPreview = () => {
    this.props.getCurrentItemData().then(data => {
      const item = Object.assign({}, data.item)
      const selectedTemplates = this.props.templates.selected || []
      item.variables = item.variables || {}
      item.variableOrder = item.variableOrder || []
      return fetch('/api/v1/items/preview', {
        method: 'POST',
        signal: this.controller.signal,
        headers: {
          Authorization: `Bearer ${this.props.auth.bearerToken}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ ...item, templateIds: selectedTemplates })
      })
    }).then(res => {
      return res.json()
    }).then(data => {
      this.setState({
        previewData: data,
        templateName: data.results[0].templateName
      })
    }).catch(() => {
      this.closeModal()
      alert('Item preview failed. Please check your connection and try again.')
    })
  }

  render () {
    let modal
    const { templateName } = this.state
    const { app: { primaryColor }, templates: { selected } } = this.props
    if (this.state.showModal) {
      const previewData = []
      if (this.state.previewData) {
        const results = this.state.previewData.results
        for (let i = 0, len = results.length; i < len; i++) {
          let value; let context; let errors
          if (results[i].context.errors && results[i].context.errors.length) {
            errors = (<div> <p>Errors:</p> <pre>{results[i].context.errors.join('\n')}</pre> </div>)
          } else {
            delete results[i].context.errors
            value = (<div> <p>Output Value:</p> <pre>{results[i].value}</pre> </div>)
            context = (<div> <p>Content:</p> <pre>{JSON.stringify(results[i].context, null, 2)}</pre> </div>)
          }
          const templatePreview = (
            <div key={results[i].templateId}>
              <h4 className={css.h4} style={{ color: primaryColor }}>{results[i].templateName}</h4>
              {errors}
              {context}
              {value}
              <br />
            </div>
          )
          previewData.push(templatePreview)
        }
      } else {
        previewData.push((<div key='__LOADING__'>Loading</div>))
      }

      modal = (
        <div className={css.bg} onClick={this.handleBgPress}>
          <article className={`${css.wrapper} ${this.props.app.standAloneMode ? css.wrapperStandAlone : ''}`}>
            <header className={css.header}>
              <h3 className={css.h3}>
                View Output
                <button className={css.reload} onClick={this.handleGetPreview}>
                  Reload Output
                </button>
              </h3>
            </header>
            <div className={css.content}>
              {previewData}
            </div>
          </article>
        </div>
      )
    }

    return (
      <div className={css.Preview}>
        <button
          type='button'
          className={`${css.btn} ${this.props.modal === 'preview' ? css.currentTab : null}`}
          onClick={this.handlePreview}
          style={{ display: selected.length ? 'block' : 'none', background: this.props.modal === 'preview' ? primaryColor : null }}
          data-modal='preview'
        >
          View Output
        </button>
        {modal}
      </div>
    )
  }
}

const mapStateToProps = state => {
  const { app, auth, item, templates } = state
  return {
    app,
    auth,
    item,
    templates
  }
}

export default connect(mapStateToProps)(ItemPreview)



// WEBPACK FOOTER //
// /app/js/components/ItemPreview/index.js